import PlanEntryDetailsRequest from "../../../api/raily/plan-entry/details/plan-entry-details.request";
import PlanEntryDetailsParams from "./plan-entry-details-params";

const create = (params: PlanEntryDetailsParams): PlanEntryDetailsRequest => {
  return {
    planEntryUuid: params.planEntryUuid,
  };
};

const planEntryDetailsParamsFactory = {
  create,
};

export default planEntryDetailsParamsFactory;
